import Bowser from 'bowser'
import BrowserNotificationError from './BrowserNotificationError'
import {
    toastBraveBlocked,
    toastBrowserNoSupport,
    toastDeniedNotification,
    toastNeedNotificationPermission
} from './toast'

let notificationAllowed = null

function promiseRequestPermission() {
    return new Promise((resolve, reject) => {
        if (!('Notification' in window)) {
            notificationAllowed = false
            return reject(BrowserNotificationError.createNoSupport())
        }

        if (Notification.permission === 'granted') {
            notificationAllowed = true
            return resolve()
        }

        if (Notification.permission === 'denied' || typeof Notification.requestPermission !== 'function') {
            notificationAllowed = false
            return reject(BrowserNotificationError.createPermissionDenied())
        }

        let toast = null

        toastNeedNotificationPermission().then((_toast) => toast = _toast)

        Notification.requestPermission(function (permission) {
            if (toast) {
                toast.hideToast()
            }

            if (permission === 'granted') {
                notificationAllowed = true
                return resolve()
            }

            notificationAllowed = false
            return reject(BrowserNotificationError.createPermissionDenied())
        })
    })
}

function throwBrowserNoSupportError(error) {
    if (error.code === 'browser-no-support') {
        let ignoreBrowser = Bowser.getParser(window.navigator.userAgent).satisfies({
            mobile: {
                'android browser': '>=0',
            },
            ios: {
                chrome: '>*',
                firefox: '>*',
                opera: '>*',
            },
            safari: '>=0',
        })

        if (ignoreBrowser) {
            console.warn(error)
            return
        }
    }

    throw error
}

export function requestPermission() {
    return promiseRequestPermission()
        .catch(error => {
            if (error.code === 'permission-denied') {
                toastDeniedNotification()
            } else if(error.code === 20){
                toastBraveBlocked()
            } else {
                toastBrowserNoSupport()
                throwBrowserNoSupportError(error)
            }
        })
}

export function isNotificationAllowed() {
    return notificationAllowed
}
